import clsx from "clsx";
import React from "react";
import PropTypes from "prop-types";

import "./DonutChart.scss";

function DonutChart(props) {
  const { score = 0, color } = props;
  return (
    <div className={clsx(`doughnut-chart p${score * 10}`, color)}>
      <span>{score}</span>
      <div className="slice">
        <div className="bar" />
        <div className="fill" />
      </div>
    </div>
  );
}

DonutChart.propTypes = {
  score: PropTypes.number,
  color: PropTypes.string,
};

export default DonutChart;
